// // siteSlice.ts
// import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// interface SiteDetails {
//   customer: string;
//   siteName: string;
//   location: string;
//   serialNo: string;
//   costCenter: string;
//   championxContact: string;
//   siteContactName: string;
//   siteContactEmail: string;
//   siteContactPhone: string;
//   alarmSelections: string;

// }
// interface SiteSliceState {
//   siteDetails: SiteDetails;
// }

// const initialState:SiteSliceState = {
//   siteDetails: {
//     customer: '',
//     siteName: '',
//     location: '',
//     serialNo: '',
//     costCenter: '',
//     championxContact: '',
//     siteContactName: '',
//     siteContactEmail: '',
//     siteContactPhone: '',
//     alarmSelections: '',
//   },
// };

// const siteSlice = createSlice({
//   name: 'siteSlice',
//   initialState,
//   reducers: {
//     setSiteDetails: (state, action: PayloadAction<SiteDetails>) => {
//       state.siteDetails = action.payload;
//     },
//     clearSiteDetails: (state) => {
//       state.siteDetails = initialState.siteDetails; 
//     },
//   },
// });

// export const { setSiteDetails, clearSiteDetails } = siteSlice.actions;
// export default siteSlice.reducer;


import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { submitSiteDetails } from '../thunk/SitesThunk';
import {SiteDetails, SiteSliceState} from '../../utils/Models';

const initialState: SiteSliceState = {
  siteDetails: {
    customer: '',
    siteName: '',
    location: '',
    serialNo: '',
    costCenter: '',
    championxContact: '',
    siteContactName: '',
    siteContactEmail: '',
    siteContactPhone: '',
    alarmSelections: '',
    status: true,
    siteId: '',
  },
  isLoading: false,
  error: '',
};

const siteSlice = createSlice({
  name: 'siteSlice',
  initialState,
  reducers: {
    setSiteDetails: (state, action: PayloadAction<SiteDetails>) => {
      state.siteDetails = action.payload;
    },
    clearSiteDetails: (state) => {
      state.siteDetails = initialState.siteDetails;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitSiteDetails.pending, (state) => {
        state.isLoading = true;
        state.error = '';
      })
      .addCase(submitSiteDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        console.log('Site created successfully:', action.payload);
        // Update only siteId as siteName is not available
        state.siteDetails.siteId = action.payload.data; // Ensure this is the correct path to siteId
        console.log('Updated State:', state.siteDetails);
      })
      .addCase(submitSiteDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  }
});

export const { setSiteDetails, clearSiteDetails } = siteSlice.actions;

export const selectSiteName = createSelector(
  (state: { siteSlice?: SiteSliceState }) => state?.siteSlice?.siteDetails?.siteName,
  (siteName) => siteName || ''
);

export const selectSiteId = createSelector(
  (state: { siteSlice?: SiteSliceState }) => state?.siteSlice?.siteDetails?.siteId,
  (siteId) => siteId || '' 
);

export default siteSlice.reducer;
